import de from "./translations/de.json";

export const commonTranslations = {
  de,
  en: () => import("./translations/en.json"),
};
